import React, { useContext } from "react";
import PropTypes from "prop-types";
import { FooterContext } from "../../../../store/context/footer-context";
import { ANALYTICS_CATEGORY } from "../index.content";
import { getTrueClasses } from "../../../../helpers";
import TrackedLink from "../../../Analytics/TrackedLink";
import "./index.scss";

const Category = ({ category, links, index }) => {
  const { t } = useContext(FooterContext);
  return (
    <ul className={getTrueClasses("GCL-F-N-C", `GCL-F-N-C_c${index + 1}`)}>
      <li>{t(category)}</li>
      {links.map(
        ({ title, url, target, action, isLink, showMobileProPopup }, i) => {
          return (
            <li key={i}>
              <TrackedLink
                path={url}
                target={!!target}
                category={ANALYTICS_CATEGORY}
                action={action ?? title.replace(/\s/g, "")}
                isLink={isLink}
                showMobileProPopup={showMobileProPopup}
              >
                {t(title)}
              </TrackedLink>
            </li>
          );
        }
      )}
    </ul>
  );
};
Category.propTypes = {
  links: PropTypes.array,
  category: PropTypes.string,
};

export default Category;
